// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : SANCTION REPORT
// MODIFIED DATE: 29-09-2025
import sanctionReportTypes from './sanction-report.types';

/** ***************** FETCH SANCTION REPORT DETAILS START *********************** */
export const getSanctionReportStart = (addData: any) => ({
	type: sanctionReportTypes.GET_SANCTION_REPORT_START,
	payload: addData,
});

export const getSanctionReportSuccess = (successData: any) => ({
	type: sanctionReportTypes.GET_SANCTION_REPORT_SUCCESS,
	payload: successData,
});

export const getSanctionReportFailure = (failureData: any) => ({
	type: sanctionReportTypes.GET_SANCTION_REPORT_FAILURE,
	payload: failureData,
});

export const getSanctionReportResponseResetStart = () => ({
	type: sanctionReportTypes.GET_SANCTION_REPORT_RESPONSE_RESET_START,
});

export const getSanctionReportResponseResetChanged = () => ({
	type: sanctionReportTypes.GET_SANCTION_REPORT_RESPONSE_CHANGED,
});

/** ***************** FETCH SANCTION REPORT DETAILS END *********************** */
